// components/DynamicPrivateRoute.js

import React, { useEffect, useState } from "react";
import axios from "axios";
import { Navigate, useLocation } from "react-router-dom";
import { Box, CircularProgress, Typography } from "@mui/material";
import { API_URL } from "./config";

const DynamicPrivateRoute = ({ children }) => {
  const location = useLocation();
  const token = localStorage.getItem("auth");

  const [state, setState] = useState({
    loading: true,
    allowed: false,
    sessionExpired: false,
  });

  useEffect(() => {
    const check = async () => {
      if (!token) {
        setState({
          loading: false,
          allowed: false,
          sessionExpired: true,
        });
        return;
      }

      try {
        const res = await axios.get(`${API_URL}/api/access/me/can-access`, {
          params: {
            path: location.pathname,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setState({
          loading: false,
          allowed: Boolean(res.data.allowed),
          sessionExpired: false,
        });
      } catch (err) {
        const status = err?.response?.status;
        const code = err?.response?.data?.code;

        if (
          status === 401 ||
          code === "TOKEN_EXPIRED" ||
          code === "INVALID_TOKEN" ||
          code === "NO_TOKEN"
        ) {
          localStorage.removeItem("auth");

          setState({
            loading: false,
            allowed: false,
            sessionExpired: true,
          });

          return;
        }

        setState({
          loading: false,
          allowed: false,
          sessionExpired: false,
        });
      }
    };

    check();
  }, [location.pathname, token]);

  if (!token || state.sessionExpired) {
    return (
      <Navigate
        to="/login"
        replace
        state={{
          message: "Your login session has timed out. Please login again.",
        }}
      />
    );
  }

  if (state.loading) {
    return (
      <Box sx={{ p: 4, textAlign: "center" }}>
        <CircularProgress size={28} />
      </Box>
    );
  }

  if (!state.allowed) {
    return (
      <Box sx={{ p: 4 }}>
        <Typography variant="h6">Access denied</Typography>
        <Typography>You do not have permission to view this page.</Typography>
      </Box>
    );
  }

  return children;
};

export default DynamicPrivateRoute;